"use client";
import Tag from "@/components/tag";
import * as Teaser from "@/components/teaser";
import { Content } from "@/services/content/types";
import { useMemo, useState } from "react";

type GridArticlesProps = {
  items: {
    articles?: Content.Article[];
    category: Content.Category;
  }[];
  initialItems: Content.Article[];
};

const GridArticles = ({ items, initialItems }: GridArticlesProps) => {
  const [category, setCategory] = useState<String | null>(null);

  const filterArticles = (
    category: String | null,
    items: GridArticlesProps["items"],
    initialItems: GridArticlesProps["initialItems"]
  ) => {
    let filteredArticles: Content.Article[] = [];
    if (!category) {
      return initialItems;
    }

    filteredArticles = items
      .filter((item) => item.category.fields.slug == category)
      .map((item) => item.articles!)
      .flat()
      .slice(0, 8);
    return filteredArticles;
  };

  const articles = useMemo(
    () => filterArticles(category, items, initialItems),
    [category, items, initialItems]
  );

  return (
    <div className="space-y-8">
      <div className="flex space-x-2 sm:space-x-4 justify-center overflow-x-auto hide-scrollbar">
        <button onClick={() => setCategory(null)}>
          <Tag
            key="defualt"
            label="Visa alla"
            className={`${
              !category ? "bg-sand-700" : "bg-sand-600"
            } whitespace-nowrap`}
          />
        </button>
        {items.map((item) => (
          <button
            key={item.category.sys.id}
            onClick={() => setCategory(item.category.fields.slug || null)}
          >
            <Tag
              label={item.category.fields.name!}
              className={`${
                item.category.fields.slug == category
                  ? "bg-sand-700"
                  : "bg-sand-600"
              }`}
            />
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 gap-y-4 md:gap-y-16">
        {articles.map((item) => (
          <Teaser.medium key={item.sys.id} item={item} />
        ))}
      </div>
    </div>
  );
};

export default GridArticles;
